import { AnimatePresence, motion } from "framer-motion";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { IconX } from "@/components/icons";
import { IconBroadcasts } from "@/components/icons/player.icons";

import { ROUTES } from "@/config/routes";
import { useGetBroadcasts } from "@/hooks/api/broadcast.hooks";

import { usePlayerControls2 } from "../hooks/PlayerControlsContext";

const OpenBroadCastSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { setControlsLock } = usePlayerControls2();
  const { t } = useTranslation();

  const { data } = useGetBroadcasts();

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
    setControlsLock(isOpen);
  };

  return (
    <>
      <div onClick={handleToggle}>
        <IconBroadcasts className="player-icon !fill-transparent" />
      </div>

      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              className="fixed inset-0 z-40 bg-black bg-opacity-40"
              onClick={handleToggle}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            />

            <motion.aside
              className="fixed right-0 top-0 z-[10000] h-full w-[400px] bg-surface p-6 max-sm:w-full"
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "tween", duration: 0.3 }}
            >
              <div className="flex items-center justify-between pb-3">
                <h3 className="text-[24px] font-semibold">{t("General.tv-channels")}</h3>
                <div onClick={handleToggle} className="cursor-pointer">
                  <IconX className="size-6 stroke-white" />
                </div>
              </div>

              <div className="h-full overflow-y-auto pb-20 pt-10">
                <div className="grid grid-cols-4 gap-3">
                  {data.map((e, i) => (
                    <Link
                      onClick={handleToggle}
                      to={ROUTES.CHANNELS.SINGLE.replace(":id", e.id.toString())}
                      key={i}
                      className="aspect-square w-full overflow-hidden rounded-xl"
                    >
                      <img src={e.icon} alt={e.title} className="h-full w-full object-cover" />
                    </Link>
                  ))}
                </div>
              </div>
            </motion.aside>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default OpenBroadCastSidebar;
